module.exports = __webpack_public_path__ + "static/media/tea.b7de270b.jpg";